import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../../Service/ApiCallMethod";
import { LIMIT_PER_PAGE } from "../../../Common/Constants";

export const getChatSummaryList = createAsyncThunk(
  "chat/summary/list",
  async (
    {
      page = 1,
      keyword = "",
      contactId = "",
      assistantId = "",
      from = "",
      to = "",
      time = "",
      isCallExternal,
      isExternalFromEmail,
      widgetChatId = "",
      vapiCallId = "",
    },
    thunkAPI
  ) => {
    try {
      const response = await getMethod(
        `chat/summary?page=${page}&limit=${LIMIT_PER_PAGE}&from=${from}&to=${to}${
          time ? `&time=${time}` : ""
        }${
          vapiCallId
            ? `&vapiCallId=${vapiCallId}`
            : widgetChatId
            ? `&widgetChatId=${widgetChatId}`
            : !isCallExternal
            ? `&contactId=${contactId}&assistantId=${assistantId}`
            : isExternalFromEmail
            ? `&emailId=${contactId}`
            : `&callId=${contactId}`
        }${keyword ? `&keyword=${keyword}` : ""}`
      );
      const data = await response.data;
      if (response.status != 200 && response.status != 201) {
        // Handle non-2xx HTTP responses
        return thunkAPI.rejectWithValue(data.message || "Something went wrong");
      }
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

const initialState = {
  chatSummaryListData: null,
  loading: false,
  error: null,
};

export const ChatSummaryListSlice = createSlice({
  name: "chat-summary",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getChatSummaryList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChatSummaryList.fulfilled, (state, action) => {
        state.loading = false;
        state.chatSummaryListData = action.payload;
        state.error = null;
      })
      .addCase(getChatSummaryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ChatSummaryListSlice.reducer;
